import { Response } from "express";

import { IResultHandler } from "./IResultHandler";

export class HtmlResultHandler implements IResultHandler {
    public async processResult(result: string, _req: Express.Request, res: Response): Promise<void> {
        res.send(result.trim());
    }
}
